/**
 * Created by danielr on 9/21/15.
 */
/**
 * Created with IntelliJ IDEA.
 * User: livnat
 * Date: 3/3/13
 * Time: 2:55 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var Button = require("ui/button/Button");
    var AppKeysGallery = require("ui.components/gallery/appKeysGallery");
    var SelectableCollectionDecorator = require("decorators/SelectableCollectionDecorator");
    var template = require("manager-templates/data-sources/integrations/app-keys/appKeysGalleryView.tmpl");
    var DropdownMenu = require("ui/dropdown-menu/DropdownMenu");
    var Ellipsis = require("ui.plugins/ellipsis");

    var ACTION_MENU_OPTIONS = {
        ADD: "add",
        EDIT: "edit"
    };

    var AppKeysGalleryView = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {

        AppKeysGalleryView = Marionette.ItemView.extend({
            template: template,
            className: "gallery-view appKeys",

            ui: {
                actionMenuContainer: ".action-menu",
                totalItems: ".total-items-number",
                galleryContainer: ".gallery-container",
                closeBtn: ".button-close"
            },

            uiComponents: {
                actionMenu:{
                    type: DropdownMenu,
                    options: {
                        name: LE.translator.translate("LEFramework.global.captions.action"),
                        el: "view.ui.actionMenuContainer",
                        collection: "view._getDropdownMenuItems",
                        tabindex: "1000",
                        align: DropdownMenu.ALIGN.RIGHT
                    },
                    events:{
                        "change": "_onActionMenuSelection"
                    }
                },
                gallery: {
                    type: AppKeysGallery,
                    options: {
                        collection :"view.galleryCollection",
                        collectionMap : {"key" : "applicationKey", "isEditable": "isEditable","isViewable":"isViewable" },
                        el :"view.ui.galleryContainer",
                        newItemToAdd: {
                            name:LE.translator.translate("LEFramework.global.captions.addNew")
                        }
                    },
                    events: {
                        "change": "_onGalleryItemClick",
                        "edit":   "_onGalleryItemEdit"
                    }
                },
                doneBtn: {
                    type: Button,
                    options: {
                        el: "view.ui.closeBtn",
                        permutation: Button.PERMUTATION.BTN_PRIMARY,
                        text: LE.translator.translate("LEFramework.global.captions.close")
                    },
                    events: {
                        "click": "_onDoneClick"
                    }
                }
            },

            initialize: function(options) {
                this._initialize(options);
            },
            onRender: function() {
                this._onRender();
            },

            _initialize: function (options) {
                LEManager.logger.info("Gallery initialized", "AppKeysGalleryView:initialize");

                this.selectedItemId = options.selectedItemId;
                this.channel = options.channel;
                this.galleryCollection = options.galleryCollection;
            },

            _onRender: function () {
                this._updateTotalNumberOfItems();
                this._toggleDropdownItems(this._getSelectedModel());
                if (this.galleryCollection.size() > 0) {
                    this.uiComponents.gallery.selectItem(this.selectedItemId);
                }

                //we either do it here with deferred or on show( since the view can not know the parent is using region Show we do it here )
                _.defer(_.bind(function(){
                    Ellipsis.handleNow(this);
                }, this));

                this.listenTo(this, "page:closeButtonClick", this._onCloseButtonClick);
            },

            _updateTotalNumberOfItems: function() {
                this.ui.totalItems.text(this.galleryCollection.size());
            },

            _onGalleryItemClick: function(componentId, eventName, itemId) {
                LEManager.logger.info("App keys gallery item clicked", "AppKeysGalleryView:onGalleryItemClick", {selected: itemId});

                if (itemId === AppKeysGallery.NEW_ITEM_KEY) {
                    this._onCreate();
                }
                else {
                    this._onSelect(itemId);
                }
            },

            _onGalleryItemEdit: function(componentId, eventName, itemId) {
                LEManager.logger.info("Edit gallery item clicked", "AppKeysGalleryView:onGalleryItemEdit", {selected: itemId});
                this._onEdit(itemId);
            },

            _getDropdownMenuItems: function () {
                var menuItems = [];

                _.each(ACTION_MENU_OPTIONS, function(actionMenu) {
                    menuItems.push({
                        "id": actionMenu,
                        "actionName": LE.translator.translate("LEFramework.global.captions." + actionMenu),
                        "enabled": true
                    });
                });

                this.dropdownMenuItems = new DropdownMenu.Collection(menuItems);

                return this.dropdownMenuItems;
            },

            _onActionMenuSelection: function(component, eventName, id){
                LEManager.logger.info("AppKeysGalleryView: user clicked on action: " + id, "AppKeysGalleryView:changeDropdownSelection");

                switch (id) {
                    case ACTION_MENU_OPTIONS.ADD:
                        this._onCreate();
                        break;
                    case ACTION_MENU_OPTIONS.EDIT:
                        this._onEdit();
                        break;
                    default:
                        break;
                }
            },

            _toggleDropdownItems: function(itemModel) {
                var editEnabled =  _.isEmpty(itemModel) ? false : itemModel.isEditable();
                this.dropdownMenuItems.get(ACTION_MENU_OPTIONS.EDIT).set("enabled", editEnabled);
            },

            _onCreate: function(){
                this.channel.trigger("GalleryView:create");
            },

            _onSelect: function(value) {
                this.selectedItemId = value;
                this._toggleDropdownItems(this._getSelectedModel());

                this.channel.trigger("GalleryView:select",this.selectedItemId);
            },

            _onEdit: function(itemId){
                itemId = itemId || this.selectedItemId;

                this.channel.trigger("GalleryView:edit", itemId);
            },

            _onCloseButtonClick: function () {
                LEManager.logger.debug("gallery: user clicked on 'close window' button.", "GalleryView:_onCloseButtonClick");
                this.channel.trigger("GalleryView:closeWindow");
            },

            _onDoneClick: function(){
                LEManager.logger.debug("gallery: user clicked on 'done' button.", "GalleryView:_onDoneClick");
                this.channel.trigger("GalleryView:done");
            },

            _getSelectedModel: function(){
                var selectedModel = null;
                if (this.galleryCollection.size() > 0) {
                    selectedModel = this.galleryCollection.get(this.selectedItemId);
                }
                return selectedModel;
            }
        });

    }

    LE.module("LEManager", moduleDefinition);

    return AppKeysGalleryView;
});

